import React from 'react';
import classNames from 'classnames';

import styles from './style.scss';


const CheckBox = ({ name, isChecked, onChange, extraClassName }) => {
  return (
    <div className={classNames(styles.checkBoxContainer, isChecked && styles.isChecked, extraClassName)}>
      <input
        id={`id-${name}`}
        name={name}
        type="checkbox"
        checked={isChecked}
        className={classNames(styles.checkBox, 'jest-slider-checkbox')}
        onChange={() => { onChange({ value: !isChecked, name }); }} />
    </div>
  );
};

export default CheckBox;
